export default "__VITE_ASSET__C_T4NETV__"